import { center } from '../../../plugins/utils/helpers';
import { MEASURE } from '../../../plugins/utils/styles/styles';
import { unByKey } from 'ol/Observable';
import EditFeatureLayer from '../../../plugins/utils/modules/EditableFeatureLayer';
import { DrawFeaturesEventType } from  '../../../plugins/layers/vector/DrawFeatures';
import { LIGHT_CONDITION } from '../../../plugins/utils/constantes';
import {
  addPolylineControlEvent,
  setlockButton,
  addStepMeasureTooltip,
  createNewTooltip,
  createPolylineControl,
  EVENT_DISABLE_DRAWING,
  EVENT_UPDATE_TOTAL_DISTANCE,
  getLineGeometryParameters,
  setTooltipStyle,
  EVENT_DRAW_STATUS
} from '../../../plugins/utils/draw/polylineMeasured';
import { getGUIColor, GREEN_COLOR } from '../../../plugins/utils/GuiColor';

export default class PolylineMeasureLayerManager extends EditFeatureLayer {
  constructor(map) {
    const lightCondition = localStorage.getItem('layerColor') || LIGHT_CONDITION.DAY;
    const greenColor = getGUIColor(GREEN_COLOR, lightCondition);
    const greenMeasureStyle = MEASURE(greenColor);

    super(map, { style: greenMeasureStyle, drawStyle: greenMeasureStyle, stopClick: true });

    this.map_ = map;
    this.sketch_ = undefined;
    this.listener_ = undefined;
    this.measureTooltip_ = undefined;
    this.measureTooltipArray_ = [];

    this.nodes = new Map();
    this.editionMode = false;
    this.transientMode = false;
    this.firstPoint = false;
    this.control = undefined;

    this.featureEditionLayer_.setVertexInsertionOnEdit(false);

    this.on(DrawFeaturesEventType.SELECTED_POINT, () => {
      if (!this.editionMode) {
        for (const tooltip of this.measureTooltipArray_) {
          setTooltipStyle(tooltip, false);
        }
        this.transientMode = false;
      }
      this.firstPoint = true;
    });

    document.addEventListener(EVENT_DISABLE_DRAWING, ({ detail }) => {
      if (detail.state) this.featureEditionLayer_.stop();
      else this.featureEditionLayer_.startEdition('LineString');
    })
  }

  onDrawStart_(e) {
    if (!this.control) {
      this.control = createPolylineControl();
      this.map_.addControl(this.control);
      addPolylineControlEvent();
    }

    this.editionMode = true;
    const event = new CustomEvent(EVENT_DRAW_STATUS, { detail: { state: true } });
    document.dispatchEvent(event);
    setlockButton();

    this.transientMode = false;
    this.firstPoint = false;
    unByKey(this.listener_);
    this.featureEditionLayer_.clear();

    this.sketch_ = e.feature;
    let tooltipCoord = e.coordinate;
    this.clearMeasureTooltips_();
    this.measureTooltip_ = createNewTooltip(true);
    this.map_.addOverlay(this.measureTooltip_);
    this.listener_ = this.sketch_.getGeometry().on('change', evt => {
      let geom = evt.target;
      let { text } = getLineGeometryParameters(geom);
      this.measureTooltip_.getElement().innerHTML = text;
      let coords = geom.getCoordinates();
      tooltipCoord = center(coords[coords.length - 2], coords[coords.length - 1]);
      this.measureTooltip_.setPosition(tooltipCoord);

      this.clearMeasureTooltips_();
      let totalDistance = 0;
      geom.forEachSegment((p1, p2) => {
        let { tooltip, distance } = addStepMeasureTooltip([p1, p2], this.transientMode);
        this.map_.addOverlay(tooltip);
        this.measureTooltipArray_.push(tooltip);
        totalDistance += distance;
      })
      const cev = new CustomEvent(EVENT_UPDATE_TOTAL_DISTANCE, { detail: totalDistance });
      document.dispatchEvent(cev);
      if (this.editionMode) {
        let lastTooltip = this.measureTooltipArray_.pop();
        this.map_.removeOverlay(lastTooltip);
      }
    });
  }

  onDrawEnd_(e) {
    this.measureTooltipArray_.push(this.measureTooltip_);
    for (const tooltip of this.measureTooltipArray_) {
      setTooltipStyle(tooltip, false);
    }
    this.editionMode = false;
    const cev = new CustomEvent(EVENT_DRAW_STATUS, { detail: { state: false } });
    document.dispatchEvent(cev);
    setlockButton();

    super.onDrawEnd_(e);
  }

  clearMeasureTooltips_() {
    for (const tooltip of this.measureTooltipArray_) {
      this.map_.removeOverlay(tooltip);
    }
    this.measureTooltipArray_ = [];
  }

  getDrawStatus() {
    return this.draw_.getActive();
  }

  clear() {
    super.clear();

    this.map_.removeOverlay(this.measureTooltip_);
    this.measureTooltip_ = undefined;

    this.clearMeasureTooltips_();
    if (this.control) {
      this.map_.removeControl(this.control);
      this.control = null;
    }
  }

  setLightCondition(lightCondition) {
    const green = getGUIColor(GREEN_COLOR, lightCondition);
    this.featureEditionLayer_.setStyle(MEASURE(green));
  }
}